import React from 'react';
import { UserComponent } from 'react/UserComponent.jsx';
import { LeagueComponent } from 'react/LeagueComponent.jsx';

import { NowPlayingWithPlayersComponent } from 'react/NowPlayingWithPlayersComponent.jsx';
import { MatchHistoryMatchComponent } from '../match/MatchHistoryMatchComponent';
import { MatchHistoryTableComponent } from '../match/MatchHistoryTableComponent';
import MatchHistoryTableLink from '../match/MatchHistoryTableLink';

class StreamComponent extends React.PureComponent {
	static defaultProps = {
		showGame: true,
		showChannelName: true,
		clickable: true,
	};

	constructor(props) {
		super(props);
		this.streamClick = this.streamClick.bind(this);
	}

	streamClick(e) {
		const { stream } = this.props;

		e.preventDefault();
		e.stopPropagation();

		stream.onClick({ x: e.nativeEvent.pageX, y: e.nativeEvent.pageY });

	}

	getMatch() {
		if(this.props.stream && this.props.stream.match) {
			return this.props.stream.match;
		}
	}

	getClickAction() {
		const { onClick } = this.props;
		return onClick || this.streamClick;
	}

	matchStyleRender() {
		const { stream, showGame, showChannelName, clickable, onClick } = this.props;
		const match = this.getMatch();
		return (
			<MatchHistoryTableComponent>
				<MatchHistoryMatchComponent
					onClick={this.getClickAction()}
					streamType='twitch'
					returnMatchOnClick={false}
					stream={stream}
					match={match}
					players={match && match.getPlayers()}
					horizontalPlayers={true}
					mainLink={
						<MatchHistoryTableLink
							url={stream.getUrl()}
						>
							<i className='fa fa-twitch' />{' '}{stream.channel_name}
						</MatchHistoryTableLink>
					}
					subtitleOne={stream.viewers > 0 &&
					<div className='viewers when'>
						<i className='fa fa-users' /> <span className='count'>{stream.viewers}</span>
					</div>}
					subtitleTwo={
						<div className='duration'>
							{stream.title}
						</div>
					}
				/>
			</MatchHistoryTableComponent>
		);
	}

	render() {
		const { stream, showGame, showChannelName, clickable, onClick, matchStyle, onPreviewImageLoad, onPreviewImageError } = this.props;
		const gameData = stream.gameData;
		const match = this.getMatch();
		if(matchStyle) {
			return this.matchStyleRender();
		}
		const clickAction = this.getClickAction();

		const imageRounded = stream.type === 'twitch';
		const isImage = stream.type === 'image';

		return (
			<div
				onClick={clickable ? clickAction : undefined}
				className={'stream_container active_stream ' + (stream.is_online ? 'is_online' : '')}>
				<div className='stream_actions'>
					<div className={`watch_stream ${clickable ? 'clickable' : ''}`} data-stream_id=''>
						<div
							className={`image_container ${isImage ? 'is_image' : ''}`}>
							{!stream.preview_url &&
							<div className='no_logo'></div>
							}
							{!!stream.preview_url &&
							<img
								onLoad={onPreviewImageLoad}
								onError={onPreviewImageError}
								className={`stream_logo ${imageRounded ? 'rounded' : ''}`}
								src={stream.preview_url} />
							}
						</div>
						<div className='stream_info_container'>
							<div className='title_info'>
								<div className='channel_stuff'>
									{showChannelName &&
									<span className='channel_name' data-channel_name=''>{stream.channel_name}</span>
									}
									<div className='stream_title'>{stream.title}</div>
									{stream.viewers > 0 &&
									<div className='viewers'>
										<i className='fa fa-users' /> <span className='count'>{stream.viewers}</span>
									</div>
									}
								</div>

								<div className='game_data'>
									<span className='user'>
											<span className='owner'>
												<UserComponent user={stream.player} />
												<LeagueComponent league={stream.league} />
											</span>

											<NowPlayingWithPlayersComponent
												match={match}
												player={stream.player}
												showAlways={true}
											/>
										</span>
									<span className='location' />
								</div>
							</div>
						</div>
						{showGame && !!gameData &&
						<div className='game_info'>
							<img className='game_logo' src={gameData.logo} />
						</div>
						}
					</div>
				</div>
			</div>
		);
	}
}

export { StreamComponent };